export enum Partner {
  ARGO = 'argo',
  BRANDON = 'brandon',
}

export enum PartnerApp {
  ARGO = 'argo',
  BRANDON = 'brandon',
  COMMUNITY = 'community',
}
